import { IGetGameUrl } from '../../types/slot';
import { IBelatraServerGame, IBelatraGetUrl } from '../../types/interfaces/Slots/Belatra';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab, hideGames } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IBelatraServerGame[]>): ISlotViewItem[] =>
    data
      .filter(t => !hideGames.includes(t.nickname.toString()))
      .map((game: IBelatraServerGame) => ({
        id: game.nickname.toString(),
        gameId: game.nickname.toString(),
        description: '',
        provider: 'belatra',
        gameName: game.gamename,
        type: CasinoType.slots,
        routeProvider: 'belatra',
        tab: getTab(game.nickname.toString()),
        imageUrl: `https://all.bltr-static.com/${game.icon[2]}`,
      }));

  convertGameUrl = ({ data }: IGetGameUrl<IBelatraGetUrl, unknown>) => data.launch_options.game_url;
}
export default Converter;
